/**
* Verifica se o valor é uma inscrição municipal válida
*
* @param {string} inscricaoMunicipal
* @returns {boolean}
*/
const validarInscricaoMunicipal = (inscricaoMunicipal) => {
  inscricaoMunicipal = inscricaoMunicipal.replace(/[^\dxX]+/g, "");

  const sequencial = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  let identificadorSemDigitoVerificador = "";
  let soma = 0;

  if (inscricaoMunicipal.length < 10)
    identificadorSemDigitoVerificador = inscricaoMunicipal.substring(0, 9).padStart(10, '0');
  else if (inscricaoMunicipal.length === 10)
    if (inscricaoMunicipal.substring(0, 1) === '0')
      identificadorSemDigitoVerificador = inscricaoMunicipal.substring(1, 9).padStart(10, '0');
    else
      if (Number(inscricaoMunicipal.substring(11, 1)))
        identificadorSemDigitoVerificador = inscricaoMunicipal;
      else
        identificadorSemDigitoVerificador = inscricaoMunicipal.substring(0, 9).padStart(10, '0');
  else
    identificadorSemDigitoVerificador = inscricaoMunicipal.padStart(11, '0').substring(0, 10);

  for (let i = 0; i < identificadorSemDigitoVerificador.length; i++)
    soma += Number(identificadorSemDigitoVerificador[i] * sequencial[i]);

  let resto = soma % 11;

  inscricaoMunicipal = inscricaoMunicipal.padStart(10, '0');
  const digitoVerificador = resto === 0 ? '0' : resto === 1 ? 'X' : 11 - resto;

  identificadorSemDigitoVerificador += digitoVerificador;

  return inscricaoMunicipal === identificadorSemDigitoVerificador;
}

module.exports = {
  validarInscricaoMunicipal,
}
